<app-base-doughnut-chart
[chartId]="chartId"
[title]="title"
[labels]="labels"
[data]="data"
[colors]="colors">
</app-base-doughnut-chart>